import React, { useState } from 'react';
import LoginPage from './pages/LoginPage';
import DashboardLayout from './components/DashboardLayout';

const API_URL = process.env.REACT_APP_API_URL || 'https://smartplage.com/api';

function App() {
  const [auth, setAuth] = useState(null);

  if (!auth) {
    return <LoginPage apiUrl={API_URL} onLogin={setAuth} />;
  }

  return (
    <DashboardLayout
      apiUrl={API_URL}
      auth={auth}
      onLogout={() => setAuth(null)}
    />
  );
}

export default App;
